import type {
  ContactMessage,
  ContactMessageListParams,
  ContactMessageListResult,
  ContactMessageStatus,
} from '@/types/contactMessage.types';

import { apiClient } from './api.service';

const cleanParams = <T extends Record<string, unknown>>(input: T): Partial<T> => {
  const out: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(input)) {
    if (value === undefined || value === '' || value === null) continue;
    out[key] = value;
  }
  return out as Partial<T>;
};

export const contactMessagesApi = {
  list: (params: ContactMessageListParams): Promise<ContactMessageListResult> =>
    apiClient
      .get<ContactMessageListResult>('/admin/contact-messages', {
        params: cleanParams(params as unknown as Record<string, unknown>),
      })
      .then((r) => r.data),

  updateStatus: (id: string, status: ContactMessageStatus): Promise<ContactMessage> =>
    apiClient
      .patch<ContactMessage>(`/admin/contact-messages/${id}`, { status })
      .then((r) => r.data),
};
